import { useRef } from 'react'
import { Button } from '@/view/components/ui/button'
import QRCode from 'react-qr-code'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/view/components/ui/dialog'
import { ArrowDownToLine, Copy } from 'lucide-react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

interface QRCodeModalProps {
  isOpen: boolean
  onClose: () => void
  linkName: string
}

const QRCodeModal = ({ isOpen, onClose, linkName }: QRCodeModalProps) => {
  const baseUrl = window.location.origin

  const fullLink = `${baseUrl}/credit/${linkName}`

  const handleCopy = () => {
    navigator.clipboard.writeText(fullLink)
  }

  const qrRef = useRef<HTMLDivElement>(null)

  const handleDownload = () => {
    if (qrRef.current) {
      const svg = qrRef.current.querySelector('svg')
      if (svg) {
        const svgData = new XMLSerializer().serializeToString(svg)
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (ctx) {
          const img = new Image()
          img.onload = () => {
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0)
            const url = canvas.toDataURL('image/png')
            const a = document.createElement('a')
            a.href = url
            a.download = 'qrcode.png'
            a.click()
          }
          img.src = 'data:image/svg+xml;base64,' + btoa(svgData)
        }
      }
    }
  }

  const formattedDateTime = format(
    new Date(),
    "d 'de' MMMM 'de' yyyy - HH:mm",
    { locale: ptBR },
  )

  if (!isOpen) return null

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader className="mt-8">
          <DialogTitle className="text-center text-xl font-semibold">
            QR Code
          </DialogTitle>
          <DialogDescription className="text-center text-sm font-medium">
            Use este QR code para divulgar e acompanhar seus resultados
          </DialogDescription>
        </DialogHeader>
        <div ref={qrRef} className="flex w-full items-center justify-center">
          <div className="mb-4 rounded-xl bg-white p-4 shadow-xl">
            <QRCode
              size={256}
              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              viewBox={`0 0 256 256`}
              value={fullLink}
              level="L"
            />
          </div>
        </div>
        <p className="mb-4 text-center text-sm font-medium text-black04">
          {formattedDateTime}
        </p>
        <div className="relative mb-4 flex items-center">
          <i className="fa-solid fa-link absolute left-2 top-1/2 -translate-y-1/2 transform cursor-pointer text-black03" />
          <input
            type="text"
            value={fullLink}
            readOnly
            className="flex-1 overflow-hidden text-ellipsis rounded-xl border bg-gray02 p-2 pl-10 pr-10"
          />
          <Copy
            onClick={handleCopy}
            className="absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer text-black03"
          />
        </div>
        <Button
          onClick={handleDownload}
          className="mb-4 flex w-full items-center gap-2 rounded-full bg-primary text-base font-semibold text-white"
        >
          Baixar <ArrowDownToLine size={20} />
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default QRCodeModal
